import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	infoMessage: {
		id: 'project-details.info-popup-content.info-message',
		defaultMessage: 'Project keys are unique keys used to identify a project.',
		description: 'Label for the body of the Previous Project Keys info popup',
	},
	infoLink: {
		id: 'project-details.info-popup-content.info-link',
		defaultMessage: 'More about project keys',
		description: 'Label for the link of the Previous Project Keys info popup',
	},
});
